import React from 'react';
import styles from './ScrollMenuArrow.module.scss';
import { CustomButton } from '../Button/Button';
import { Icon } from '../Icon';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

// Button tyle - RIGHT or LEFT
const ScrollMenuArrow = ({ type = 'LEFT', disabled, onClick }) => {
  const { t } = useTranslation();

  if (type === 'LEFT') {
    return (
      <CustomButton variant="basic" disabled={disabled} className={cx(styles.controlButton, styles.backButton)} onClick={onClick} ariaLabel={t('general.back')}>
        <Icon src="backIcon" />
      </CustomButton>
    );
  } else if (type === 'RIGHT') {
    return (
      <CustomButton variant="basic" disabled={disabled} className={cx(styles.controlButton, styles.forwardButton)} onClick={onClick} ariaLabel={t('accessibility.forward')}>
        <Icon src="forwardIcon" />
      </CustomButton>
    );
  }
  return <></>;
};

export default ScrollMenuArrow;
